export const SERVICE = 'ONLINE_CHANNEL'
export const COMPANIES = {
  '/middleware/companies/908caa91-238b-4fd3-85fd-9b0adbc67aae': 'gns',
  '/middleware/companies/2a1f6a03-d056-4e8d-af97-7603b1375c9f': 'nycli',
  '/middleware/companies/a6ca0215-3eac-4bc3-99f1-519d36f2c738': 'cor',
}
